import React, { useState, useEffect } from 'react';
import { Button, Card, Table } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';

const { submitAppointment } = useAPI();

export default class Appointment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            get: [],
            type: [],
            post: [],
            submit: '',
            minDate: '',
            maxDate: '',
            minTime: '',
            maxTime: '',
            isDisabled: false,
            isDateDisabled: false,
        };
        this.submitAppointment = this.submitAppointment.bind(this);
    }

    getResponse(data) {
        this.setState({
            get: data
        });
    }

    typeResponse(data) {
        this.setState({
            type: data
        });
    }

    // Convert 12-hour time to 24-hour format
    convertTo24Hour = (hour, minute, meridiem) => {
        let hours = parseInt(hour);
        if (meridiem === 'PM' && hours !== 12) {
            hours += 12;
        } else if (meridiem === 'AM' && hours === 12) {
            hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minute.padStart(2, '0')}`;
    }

    // Convert 24-hour time to 12-hour format for display
    convertTo12Hour = (time24) => {
        const [hours, minutes] = time24.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const hours12 = hours % 12 || 12;
        return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
    }

    submitAppointment() {
        var desc = document.getElementById('appdes').value;
        var date = document.getElementById('appdate').value;
        var hour = document.getElementById('apphour').value;
        var minute = document.getElementById('appminute').value;
        var meridiem = document.getElementById('appmeridiem').value;

        let cnf = window.confirm('Are you sure you want to submit appointment?');
        if (cnf === true) {
            if (!hour || !minute || !meridiem) {
                alert('Please select complete time (hour, minute, and AM/PM)');
                return;
            }

            const time = this.convertTo24Hour(hour, minute, meridiem);

            if (!this.isTimeInRange(time)) {
                var selectedDate = new Date(date);
                const dayOfWeek = selectedDate.getDay();
                if (dayOfWeek === 6) {
                    alert("Selected time must be between 10:30 AM and 1:30 PM.");
                } else {
                    alert("Selected time must be between 3:30 PM and 5:30 PM.");
                }
                this.clearTimeInput();
                return;
            }

            if (time === '' || desc === '' || date === '') {
                alert('All the fields are required');
            } else {
                submitAppointment(date, time, desc).then((data) => {
                    this.setState({
                        post: data
                    });
                    if (this.state.post.error === false) {
                        document.getElementById('status').innerHTML = 
                            `<div class='successmsg mt-2 mb-2'>${this.state.post.errormsg}</div>`;
                    } else {
                        alert('Appointment submitted successfully');
                    }
                });
            }
        }
    }

    componentDidMount() {
        const { getAppointments } = useAPI();
        getAppointments()
            .then((response) => this.getResponse(response))
            .catch((error) => console.error(error));
        this.initializeDatesAndTimes();
    }

    initializeDatesAndTimes() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const todayFormatted = `${year}-${month}-${day}`;

        // Get the dates for the next 7 days excluding Sundays
        let oneWeekFromToday = new Date(today);
        let dates = [];

        while (dates.length < 6) {
            oneWeekFromToday.setDate(oneWeekFromToday.getDate() + 1);
            if (oneWeekFromToday.getDay() !== 0) {
                const futureYear = oneWeekFromToday.getFullYear();
                const futureMonth = String(oneWeekFromToday.getMonth() + 1).padStart(2, '0');
                const futureDay = String(oneWeekFromToday.getDate()).padStart(2, '0');
                dates.push(`${futureYear}-${futureMonth}-${futureDay}`);
            }
        }

        this.setState({
            minDate: todayFormatted,
            maxDate: dates[dates.length - 1],
        });
    }

    updateTimeConstraints(dayOfWeek) {
        if (dayOfWeek >= 1 && dayOfWeek <= 5) {
            this.setState({
                minTime: '15:30',
                maxTime: '17:30',
                isDisabled: false,
                isDateDisabled: false,
            });
        } else if (dayOfWeek === 6) {
            this.setState({
                minTime: '09:00',
                maxTime: '12:00',
                isDisabled: false,
                isDateDisabled: false,
            });
        } else {
            this.setState({
                isDisabled: true,
                isDateDisabled: true,
            });
        }
    }

    handleDateChange = (event) => {
        event.preventDefault();
        const selectedDate = new Date(event.target.value);
        const today = new Date();

        const timeDiff = selectedDate.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (daysDiff < 0) {
            alert("Please select a valid date.");
            event.target.value = '';
            this.clearTimeInput();
            return;
        } else if (daysDiff >= 7) {
            alert("Selected date is more than 7 days from today. Please choose another date.");
            event.target.value = '';
            this.clearTimeInput();
            return;
        }
    }

    clearTimeInput() {
        const hourInput = document.getElementById('apphour');
        const minuteInput = document.getElementById('appminute');
        const meridiemInput = document.getElementById('appmeridiem');
        
        if (hourInput) hourInput.value = '';
        if (minuteInput) minuteInput.value = '';
        if (meridiemInput) meridiemInput.value = '';
    }

    isTimeInRange = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        const selectedDate = new Date(document.getElementById('appdate').value);
        const dayOfWeek = selectedDate.getDay();
        
        if (dayOfWeek === 6) {
            // Saturday: 10:30 AM to 1:30 PM (10:30 to 13:30)
            return (hours > 10 || (hours === 10 && minutes >= 30)) && 
                   (hours < 13 || (hours === 13 && minutes <= 30));
        } else {
            // Weekdays: 3:30 PM to 5:30 PM (15:30 to 17:30)
            return (hours > 15 || (hours === 15 && minutes >= 30)) && 
                   (hours < 17 || (hours === 17 && minutes <= 30));
        }
    }

    render() {
        const { get, type, post, minDate, maxDate, minTime, maxTime, isDisabled, isDateDisabled } = this.state;

        const FirstTab = () => {
            return (
                <div className="FirstTab">
                    <Card
                        title="Preferred Date:"
                        body={
                            <input 
                                type="date"
                                id="appdate"
                                className="complaintoptions form-control mb-1"
                                min={minDate} 
                                max={maxDate} 
                                onChange={this.handleDateChange}
                                disabled={isDateDisabled}
                            />
                        }
                    />
                    <Card
                        title="Preferred Time:"
                        body={
                            <div className="d-flex gap-2">
                                <select 
                                    id="apphour" 
                                    className="form-control"
                                    disabled={isDisabled}
                                >
                                    <option value="">Hour</option>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(hour => (
                                        <option key={hour} value={hour}>{hour}</option>
                                    ))}
                                </select>

                                <select 
                                    id="appminute" 
                                    className="form-control"
                                    disabled={isDisabled}
                                >
                                    <option value="">Min</option>
                                    {['00', '15', '30', '45'].map(min => (
                                        <option key={min} value={min}>{min}</option>
                                    ))}
                                </select>

                                <select 
                                    id="appmeridiem" 
                                    className="form-control"
                                    disabled={isDisabled}
                                >
                                    <option value="">AM/PM</option>
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                </select>
                            </div>
                        }
                    />
                    <Card
                        title="Reason for Appointment:"
                        body={
                            <div>
                                <textarea
                                    id="appdes"
                                    className="complainttext form-control mt-2 mb-2"
                                    rows="8"
                                    name="description"
                                ></textarea>
                                <Button
                                    type="submit"
                                    onClick={this.submitAppointment}
                                    className="complaintsubmit mb-2"
                                    color="blue"
                                >
                                    Submit
                                </Button>
                                <div id="status"> </div>
                            </div>
                        }
                    />
                </div>
            );
        };

        const SecondTab = () => {
            if (get === null || get.length === 0) {
                return (
                    <div className="SecondTab">
                        <div className="container">NO APPOINTMENTS FOUND</div>
                    </div>
                );
            }
            return (
                <div className="SecondTab">
                    <Card
                        title='APPOINTMENTS'
                        body={
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.ColHeader>
                                            Preferred Date
                                        </Table.ColHeader>
                                        <Table.ColHeader>
                                            Preferred Time
                                        </Table.ColHeader>
                                        <Table.ColHeader>
                                            Reason for Appointment
                                        </Table.ColHeader>
                                        <Table.ColHeader>
                                            Status
                                        </Table.ColHeader>
                                        <Table.ColHeader>
                                            Remarks
                                        </Table.ColHeader>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {get.reverse().map((complaint, index) => (
                                        <Table.Row key={index}>
                                            <Table.Col>
                                                {complaint.date}
                                            </Table.Col>
                                            <Table.Col>
                                                {this.convertTo12Hour(complaint.time)}
                                            </Table.Col>
                                            <Table.Col>
                                                {complaint.desc}
                                            </Table.Col>
                                            <Table.Col>
                                                {complaint.state === 'Resolved' ? (
                                                    <span style={{ color: 'green' }}>{complaint.state}</span>
                                                ) : (
                                                    <span style={{ color: 'orange' }}>{complaint.state}</span>
                                                )}
                                            </Table.Col>
                                            <Table.Col>
                                                {complaint.remarks}
                                            </Table.Col>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        }
                    />
                </div>
            );
        };

        const Tabs = () => {
            const [activeTab, setActiveTab] = useState('tab1');
            const handleTab1 = () => {
                setActiveTab('tab1');
            };
            const handleTab2 = () => {
                setActiveTab('tab2');
            };
            return (
                <div className="Tabs">
                    <ul className="navtab">
                        <li
                            style={{ justifyContent: 'center' }}
                            className={activeTab === 'tab1' ? 'active' : ''}
                            onClick={handleTab1}
                        >
                            <i className="fe fe-file-text"></i>
                            <div>New Appointment</div>
                        </li>
                        <li
                            className={activeTab === 'tab2' ? 'active' : ''}
                            onClick={handleTab2}
                        >
                            <i className="fe fe-bookmark"></i>
                            <div>My Appointments</div>
                        </li>
                    </ul>
                    <div className="outlet">
                        {activeTab === 'tab1' ? <FirstTab /> : <SecondTab />}
                    </div>
                </div>
            );
        };

        return (
            <div className="container">
                <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Schedule Appointment</div>
                </div>
                <Tabs></Tabs>
            </div>
        );
    }
}
